import { createAction } from 'redux-actions';
import { LEFT_PANELS } from 'constants/feature/panel-constants';

const updateComfortLetterElementsMapFromArrayAction = createAction(
  'UPDATE_COMFORT_LETTER_ELEMENTS_MAP_FROM_ARRAY_ACTION',
);
export const updateComfortLettersElementsMapArray =
  ({ elementsArray }) =>
  async (dispatch, getState) => {
    if (
      getState().ui.statementPage.panels.left !== LEFT_PANELS.COMFORT_ANNOTATION
    )
      return;
    if (elementsArray) {
      dispatch(updateComfortLetterElementsMapFromArrayAction(elementsArray));
    }
  };
